import { render, staticRenderFns } from "./setores-risco-editar.vue?vue&type=template&id=9fe8d4f6&"
import script from "./setores-risco-editar.vue?vue&type=script&lang=js&"
export * from "./setores-risco-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports